var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrokes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 133,
    viewBox: "0 0 159 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.834 57.1406L93.4494 43.6244L103.58 44.0857L102.964 57.6019L92.834 57.1406Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.2246 105.143L37.2194 95.6586L46.7034 94.6535L47.7086 104.137L38.2246 105.143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.6523 65.8926L54.5343 58.8691L61.5577 60.7511L59.6758 67.7745L52.6523 65.8926Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M102.635 126.648L110.519 120.449L115.231 126.443L107.347 132.642L102.635 126.648Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.159 82.6198C27.1254 79.0133 24.9851 75.3063 21.3787 74.3399C17.7722 73.3736 14.0652 75.5138 13.0989 79.1203C12.1325 82.7268 14.2727 86.4338 17.8792 87.4001C21.4857 88.3665 25.1927 86.2262 26.159 82.6198Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M144.241 77.2525C145.117 73.9829 143.176 70.6221 139.907 69.746C136.637 68.8699 133.276 70.8103 132.4 74.0799C131.524 77.3495 133.465 80.7102 136.734 81.5863C140.004 82.4624 143.364 80.5221 144.241 77.2525Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.0527 60.2899C31.6171 59.2946 34.7787 60.1609 36.4905 62.3117C36.8919 62.823 37.2202 63.3917 37.3785 64.0206C37.609 64.9187 37.4804 65.8649 37.3681 66.7866C36.947 70.2597 36.9714 74.2945 39.5905 76.6114C42.1696 78.8984 46.4197 78.3932 49.0675 76.1897",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.64407 111.758C10.251 113.978 10.978 116.288 12.6085 117.917C14.2414 119.537 17.0754 120.191 18.8681 118.739C21.3506 116.722 20.1855 112.602 21.7017 109.778C22.9876 107.383 26.0473 106.405 28.7375 106.77",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M114.33 50.1432C117.501 53.1654 121.942 54.8169 126.311 54.6224C128.444 54.5208 130.711 53.917 132.077 52.264C134.01 49.9269 133.366 46.197 131.308 43.9729C130.167 42.744 128.072 41.9136 126.897 43.108C126.037 43.9833 126.215 45.4347 126.669 46.5754C128.046 50.0495 131.515 52.6037 135.24 52.8714C138.966 53.1391 142.773 51.1307 144.641 47.8914C145.413 46.5506 145.867 45.0377 146.152 43.5085C146.901 39.5273 146.517 35.3288 145.071 31.5381",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M59.1682 46.9997C58.3007 47.1518 57.4392 47.2094 56.5725 47.1791C54.9742 47.1161 53.3638 46.7039 52.1364 45.6155C50.9091 44.5271 50.1498 42.6605 50.4942 40.8011",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M25.2711 42.7228C29.8087 42.9388 33.9936 46.4444 34.989 50.8739",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M76.0102 22.4282C74.49 18.3151 71.5262 15.6207 69.3902 16.4101C67.2543 17.1996 66.7551 21.1738 68.2753 25.2869C69.7955 29.4 72.7593 32.0944 74.8953 31.305C77.0312 30.5156 77.5304 26.5413 76.0102 22.4282Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M68.9194 45.5379L75.9998 57.8277L83.4507 49.4315L68.9194 45.5379Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M55.3101 120.66L65.2418 121.591L60.4253 108.494L55.3101 120.66Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M104.239 76.6979C104.239 76.6979 113.638 77.2457 117.734 74.6994C117.734 74.6994 115.439 72.7866 116.117 69.1421C116.787 65.4951 102.584 70.9958 102.584 70.9958L104.239 76.6979Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M97.8697 30.4825C98.2765 27.9957 99.0122 25.501 100.444 23.4234C101.875 21.3458 104.083 19.707 106.578 19.3661",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M85.2772 150.855C87.9862 149.033 89.1813 145.614 89.4274 142.363C89.9058 136.021 87.2762 129.509 82.5041 125.289",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M117.977 108.844C123.199 112.858 129.365 115.645 135.833 116.907",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M91.7398 116.486C90.224 116.474 88.7579 115.918 87.4392 115.17C87.2318 115.047 87.0154 114.922 86.8996 114.708C86.714 114.361 86.8586 113.928 87.0493 113.575C88.008 111.756 89.7902 110.522 91.6391 109.614C92.5363 109.172 93.4843 108.791 94.4864 108.675C95.9623 108.513 97.4997 108.983 98.6255 109.948C98.7654 110.072 98.9118 110.207 98.9582 110.392C99.0064 110.607 98.9104 110.822 98.8127 111.007C97.4673 113.589 94.8748 116.518 91.7398 116.486Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M81.8755 104.207L71.8371 97.3189L78.515 87.5868L88.5534 94.4749L81.8755 104.207Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M79.0942 74.6545C79.8508 71.8307 78.1751 68.9283 75.3513 68.1716C72.5276 67.415 69.6251 69.0908 68.8685 71.9145C68.1119 74.7382 69.7876 77.6407 72.6114 78.3973C75.4351 79.1539 78.3376 77.4782 79.0942 74.6545Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M79.0991 74.6543L89.5043 74.8947",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M108.175 99.7865C109.167 98.5237 110.015 97.1166 110.366 95.5569C110.716 93.9973 110.509 92.2593 109.546 90.9727C108.002 88.9148 102.04 86.4426 101.56 90.3517C101.171 93.5259 105.945 98.1316 108.175 99.7865Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M56.8645 98.1554C60.3613 94.7565 63.8558 91.3666 67.3616 87.9701C62.8254 88.6101 58.1978 88.6584 53.6523 88.1134",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokes1);
export default __webpack_public_path__ + "static/media/strokes-1.9d3ee006289fa0f2f95955faa56cb6ca.svg";
export { ForwardRef as ReactComponent };